
import { useState, useEffect, useRef } from 'react';

// Singleton per memorizzare lo stato globale di attività della finestra
const windowActiveState = {
  isActive: !document.hidden,
  lastChangeTime: Date.now(),
  listeners: new Set<(isActive: boolean) => void>()
};

const initializeGlobalListener = () => {
  let initialized = false;
  
  return () => {
    if (!initialized) {
      document.addEventListener('visibilitychange', () => {
        const now = Date.now();
        
        // Aggiorna lo stato solo se è effettivamente cambiato
        if (windowActiveState.isActive !== !document.hidden) {
          windowActiveState.isActive = !document.hidden;
          windowActiveState.lastChangeTime = now;
          
          // Notifica tutti i sottoscrittori
          windowActiveState.listeners.forEach(listener => {
            listener(windowActiveState.isActive);
          });
        }
      });
      
      initialized = true;
    }
  };
};

const setupGlobalListener = initializeGlobalListener();

/**
 * Hook ottimizzato per monitorare lo stato attivo della finestra
 * senza causare refresh non necessari
 */
export const useWindowActive = () => {
  const [isActive, setIsActive] = useState(windowActiveState.isActive);

  useEffect(() => {
    setupGlobalListener();
    
    const handleVisibilityChange = (newIsActive: boolean) => {
      setIsActive(newIsActive);
    };
    
    windowActiveState.listeners.add(handleVisibilityChange);
    
    if (isActive !== windowActiveState.isActive) {
      setIsActive(windowActiveState.isActive);
    }
    
    return () => {
      windowActiveState.listeners.delete(handleVisibilityChange);
    };
  }, []);

  return isActive;
};
